export default "__VITE_ASSET__CSZXYmXt__"